import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import ResourseButtons from "../../components/form/buttons/ResourseButtons";
import InputField from "../../components/form/InputField";
import PhoneInputField from "../../components/form/PhoneInputField";
import SelectField from "../../components/form/SelectField";
import SingleFileUpload from "./../../components/form/SingleFileUpload";

const UpdateProfile = ({ id }) => {
  const dispatch = useDispatch();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    try {
    } catch (error) {}
  };

  return (
    <div className=" min-w-[85vw] sm:min-w-[35rem] lg:min-w-[40rem">
      <div className="    py-6 border-b border-bkg2 mb-4 text-text-1/90">
        <h4 className="text-text-1/80">Update Profile</h4>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="sm:flex sm:gap-3">
          <div className="flex-1">
            <PhoneInputField
              register={register}
              setValue={setValue}
              label="Phone"
              name="phone"
              errors={errors.phone}
            />
            <PhoneInputField
              register={register}
              setValue={setValue}
              label="Mobile"
              name="phone2"
              errors={errors.phone2}
            />
            <SelectField
              register={register}
              label="Gender"
              data={[
                { id: "", name: " -- Select Gender" },
                { id: "male", name: "Male" },
                { id: "female", name: "Female" },
              ]}
              name="gender"
              errors={errors.gender}
            />
          </div>

          <div className="flex-1 flex items-center justify-center">
            <div className="flex flex-col items-center justify-center m-7 border border-bkg2 shadow rounded-md  w-44 h-44  ">
              {/* <p className="py-2 text-text-1/60 text-sm">Select Image </p> */}
              <div>
                <SingleFileUpload
                  accept="image/*"
                  name="image_url"
                  register={register}
                  setValue={setValue}
                  errors={errors.image_url}
                />
              </div>
            </div>
          </div>
        </div>

        <ResourseButtons submitText="Save" />
      </form>
    </div>
  );
};

export default UpdateProfile;
